<template>
    <v-dialog
      :value="showConfirm"
      @input="hideConfirm"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">{{ options.title }}</v-card-title>

        <v-card-text>
          {{ options.message }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green"
            @click="confirm"
          >
            {{ options.confirmMessage }}
          </v-btn>

          <v-btn
            color="red"
            @click="reject"
          >
            {{ options.rejectMessage }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'TheConfirm',
    computed: {
      ...mapState('confirm', ['showConfirm', 'options']),
    },
    methods: {
      ...mapActions('confirm', ['confirm', 'reject', 'hideConfirm']),
      buttonPressed(event) {
        if (event.keyCode === 27) {
          this.reject();
        } else if (event.keyCode === 13) {
          this.confirm();
        }
      },
    },
    watch: {
      showConfirm(show) {
        if (show) {
          window.addEventListener('keydown', this.buttonPressed);
        } else {
          window.removeEventListener('keydown', this.buttonPressed);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .v-dialog__content {
    height: auto;
    & .v-dialog {
      & > .v-card {
        & > .v-card__title {
          padding: 10px 16px;
        }
        & > .v-card__text {
          padding: 5px 16px;
        }
        & > .v-card__actions {
          padding: 7px 16px;
        }
      }
    }
  }
</style>
